import React from "react";
import { Flex, Spin } from "antd";
const Spinder = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <Spin size="small" tip="Loading..." color="#13c2c2" />
    </div>
  );
};

export default Spinder;
